import React from 'react';
import PageHeader from '../components/layouts/PageHeader';
import {Route, Switch} from 'react-router-dom';
import IndexPage from './index';
import ManageUserPage from './manage/user';
import ManageTermPage from './manage/term';
import SubmissionListPage from './submission/List';
import useCheckAuth from '../hooks/useCheckAuth';
import useAuth from '../utils/AuthContext';
import {useMount} from 'react-use';
import LoginForm from '../components/user/LoginForm';
import SubmissionDetailPage from './submission/Detail';
import ManageUserStatusPage from './manage/userStatus';

function AppPage() {
  const checkAuth = useCheckAuth();
  const auth = useAuth();

  useMount(() => {
    checkAuth.check();
  });
  return (
    <div className={'AppPage'}>
      <PageHeader />
      {checkAuth.isChecking && <div className={'pageBody'}>加载中</div>}
      {!checkAuth.isChecking && !auth.currentUser && (
        <div className={'pageBody'}>
          <LoginForm />
        </div>
      )}
      {!checkAuth.isChecking && auth.currentUser && (
        <div className={'pageBody'}>
          <Switch>
            <Route path={'/'} exact component={IndexPage} />
            <Route path={'/manage/user'} component={ManageUserPage} />
            <Route path={'/manage/userStatus'} component={ManageUserStatusPage} />
            <Route path={'/manage/term'} component={ManageTermPage} />
            <Route path={'/submission/list'} component={SubmissionListPage} />
            <Route path={'/submission/detail'} component={SubmissionDetailPage} />
          </Switch>
        </div>
      )}
    </div>
  );
}
export default AppPage;
